import { useGoalById } from 'features/goals';
import React, { useMemo, useRef } from 'react';
import { useParams } from 'react-router';
import { Plus, Sort } from 'shared/assets/icons';
import { Colors, IconButton, Sizes } from 'shared/components/ui/icon-button';
import { useOpenMenu } from 'shared/hooks/use-open-menu';

import { ActionPlanContextMenu } from '../action-plan-context-menu';
import { ActionPlanSortMenu } from '../action-plan-sort-menu';
import * as Styled from './sub-items-section.style';

export const Interactions: React.FC = () => {
  const actionContextButtonRef = useRef<HTMLButtonElement>(null);
  const sortButtonRef = useRef<HTMLButtonElement>(null);

  const { id } = useParams();
  const goal = useGoalById(id);

  const {
    menuOpen: actionContextOpen,
    openMenu: openActionContext,
    closeMenu: closeActionContext,
  } = useOpenMenu();
  const {
    menuOpen: sortMenuOpen,
    openMenu: openSortMenu,
    closeMenu: closeSortMenu,
  } = useOpenMenu();

  const mainParentIds = useMemo(
    () => [...(goal?.parentIds ?? []), goal?.id!],
    [goal],
  );

  return (
    <Styled.InteractionsContainer>
      <IconButton
        icon={Sort}
        ref={sortButtonRef}
        onClick={openSortMenu}
        size={Sizes.Medium}
        color={Colors.Default}
      />
      <IconButton
        icon={Plus}
        ref={actionContextButtonRef}
        onClick={openActionContext}
        size={Sizes.Medium}
        color={Colors.Default}
      />

      {sortMenuOpen && goal && (
        <ActionPlanSortMenu
          referenceElement={sortButtonRef}
          onClose={closeSortMenu}
          goal={goal}
        />
      )}
      {actionContextOpen && (
        <ActionPlanContextMenu
          referenceElement={actionContextButtonRef}
          onClose={closeActionContext}
          id={id}
          parentIds={mainParentIds}
          lifeAreaId={goal?.lifeAreaId}
        />
      )}
    </Styled.InteractionsContainer>
  );
};
